import { Roadmap, RmStep, RoadmapArtwork, RoadmapSaveStatus } from './Sidebar';
import { EDIT_OBJECT_STEPS } from '../EditObjectSteps';

interface Props {
  activeStepIndex: number;
  onStepChange: (idx: number) => void;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
  /** Artwork identifier (thumb + title + ALI ID) shown above the step list. */
  artwork?: RoadmapArtwork;
  /** Save-status footer shown below the step list (hidden when collapsed). */
  saveStatus?: RoadmapSaveStatus;
}

/**
 * Renders the 11-step Hi-Fi roadmap sidebar as a flat list. Optional steps
 * are visually muted via the `.optional` class (italic text, dashed dot)
 * but always visible. Steps no longer track per-tab completion state — they
 * render with their static number, leaving the active step highlighted.
 */
export const EditObjectRoadmap = ({
  activeStepIndex,
  onStepChange,
  collapsed,
  onToggleCollapse,
  artwork,
  saveStatus,
}: Props) => (
  <Roadmap
    collapsed={collapsed}
    onToggleCollapse={onToggleCollapse}
    artwork={artwork}
    saveStatus={saveStatus}
  >
    {EDIT_OBJECT_STEPS.map((step, idx) => (
      <RmStep
        key={step.id}
        number={idx + 1}
        label={step.label}
        active={idx === activeStepIndex}
        optional={step.optional}
        onClick={() => onStepChange(idx)}
      />
    ))}
  </Roadmap>
);
